import classNames from 'classnames'
import * as React from 'react'

import {useBuildStatusIcon} from '../../../../hooks/useBuildStatusIcon'
import {BuildStatusType} from '../../../../types'
import {isWaitReasonWithWarning, isWaitReasonWithAnimation} from '../../../../utils/waitReason'
import {formatBuildNumber} from '../../BuildNumber/BuildNumber.utils'
import DotsLoader from '../../DotsLoader/DotsLoader'
import LinkWithIcon from '../../LinkWithIcon/LinkWithIcon'
import RouterLinkWrapper from '../../RouterLinkWrapper/RouterLinkWrapper'

import type {Props} from './BuildStatusLink.types'
import {useTitle} from './BuildStatusLink.utils'
import BuildStatusTooltip from './BuildStatusTooltip/BuildStatusTooltip.container'

import styles from './BuildStatusLink.css'

export default function BuildStatusLink(props: Props) {
  const {
    className,
    buildId,
    buildUrl,
    statusType,
    isSakuraUI = false,
    useNumber,
    number,
    isQueued = false,
    queuePosition,
    waitReason,
    withIcon = true,
    noLink,
  } = props
  const icon = useBuildStatusIcon(buildId)
  const title = useTitle(props)
  const text =
    useNumber === true
      ? formatBuildNumber({
          number,
          isQueued,
          queuePosition,
        }).text
      : title
  const iconTitle = React.useMemo(() => <BuildStatusTooltip buildId={buildId} />, [buildId])
  const linkClassName = classNames(className, styles.link, {
    [styles.success]: isSakuraUI && statusType === BuildStatusType.SUCCESS,
    [styles.failure]: isSakuraUI && statusType === BuildStatusType.FAILURE,
    [styles.canceled]: isSakuraUI && statusType === BuildStatusType.CANCELED,
    [styles.warning]: isQueued && isWaitReasonWithWarning(waitReason),
  })
  return text != null && text.length > 0 ? (
    <RouterLinkWrapper>
      <LinkWithIcon
        tailLength={0}
        icon={withIcon ? icon : null}
        iconTitle={withIcon ? iconTitle : null}
        href={buildUrl}
        className={linkClassName}
        textTitle={title}
        rightNodes={isQueued && isWaitReasonWithAnimation(waitReason) ? <DotsLoader /> : undefined}
        noLink={noLink}
      >
        {text}
      </LinkWithIcon>
    </RouterLinkWrapper>
  ) : null
}
